import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { PurposeActions } from './purpose.actions';

@Injectable({
  providedIn: 'root'
})
export class PurposeEffects {
  sendPurposeEffect$: Observable<Action>;

  constructor(private actions$: Actions) {
    this.sendPurposeEffect$ = createEffect(
      (): any =>
        this.actions$.pipe(
          ofType(PurposeActions.submitSuccess),
          tap(() => {})
        ),
      { dispatch: false }
    );
  }
}
